export default __webpack_public_path__ + "static/media/border-curve-lg.31177de3.svg";